export function getTourV2MemberDisplayPrice(
  option: App.Tours.TourV2OfferPurchasableOption | undefined,
): number | undefined {
  if (!option) return undefined
  const price = option.ltleBundleId ? option.bundleMemberPrice : option.memberPrice
  return price !== undefined && price > 0 ? price : undefined
}

export default function getTourV2DepartureDisplayPrice(
  option: App.Tours.TourV2OfferPurchasableOption,
  displayMemberPrice: boolean,
): number {
  return (option.ltleBundleId ? option.bundledPrice : undefined) ?? (displayMemberPrice && option.memberPrice ? option.memberPrice : option.price)
}
